/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecentHotel } from './RecentHotel';
import {
    RecentHotelFromJSON,
    RecentHotelFromJSONTyped,
    RecentHotelToJSON,
    RecentHotelToJSONTyped,
} from './RecentHotel';

/**
 *
 * @export
 * @interface RecentHotelCollection
 */
export interface RecentHotelCollection {
    /**
     *
     * @type {Array<RecentHotel>}
     * @memberof RecentHotelCollection
     */
    items: Array<RecentHotel>;
    /**
     *
     * @type {string}
     * @memberof RecentHotelCollection
     */
    nextCursor: string | null;
}

/**
 * Check if a given object implements the RecentHotelCollection interface.
 */
export function instanceOfRecentHotelCollection(value: object): value is RecentHotelCollection {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('nextCursor' in value) || value['nextCursor'] === undefined) return false;
    return true;
}

export function RecentHotelCollectionFromJSON(json: any): RecentHotelCollection {
    return RecentHotelCollectionFromJSONTyped(json, false);
}

export function RecentHotelCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentHotelCollection {
    if (json == null) {
        return json;
    }
    return {

        'items': ((json['items'] as Array<any>).map(RecentHotelFromJSON)),
        'nextCursor': json['next_cursor'],
    };
}

export function RecentHotelCollectionToJSON(json: any): RecentHotelCollection {
    return RecentHotelCollectionToJSONTyped(json, false);
}

export function RecentHotelCollectionToJSONTyped(value?: RecentHotelCollection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'items': ((value['items'] as Array<any>).map(RecentHotelToJSON)),
        'next_cursor': value['nextCursor'],
    };
}
